import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { AppConfigService, AuthService } from '../services';
import { AppConfigUtils } from '../utils';
import { EXCLUDE_OAUTH_INTERCEPTOR_HEADER } from './oauth-interceptor.constants';

export { EXCLUDE_OAUTH_INTERCEPTOR_HEADER } from './oauth-interceptor.constants';
/**
 * OAuthInterceptor
 *
 * @export
 * @class OAuthInterceptor
 * @typedef {OAuthInterceptor}
 * @implements {HttpInterceptor}
 */
@Injectable()
export class OAuthInterceptor implements HttpInterceptor {
  /**
   * Creates an instance of OAuthInterceptor.
   *
   * @constructor
   * @param {AuthService} authService
   * @param {AppConfigUtils} appConfigUtils
   */
  constructor(
    private readonly authService: AuthService,
    private readonly appConfigUtils: AppConfigUtils,
    private readonly appConfigService: AppConfigService
  ) {}

  /**
   * Intercept http requests and add the Authorization header if the request is for the internal API
   *
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludeConditions = [
      req.headers.has(EXCLUDE_OAUTH_INTERCEPTOR_HEADER),
      !this.authService.isLogged(),
      !this.appConfigUtils.isApiUrlIn(req.url),
    ];

    if (excludeConditions.some(condition => condition)) {
      return next.handle(req);
    }

    let authReq = req.clone();

    if (!this.appConfigService.getConfig()?.gatewayLogin) {
      authReq = authReq.clone({
        headers: authReq.headers.set('Authorization', `Bearer ${this.authService.accessToken}`),
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden) {
          this.authService.login();
        }
        return throwError(() => error);
      })
    );
  }
}
